let pending;
let loadedRuntime;
let staticImportFailed = false;
let retrySequence = 0;

async function retryFailedImport() {
  const response = await fetch(new URL('manifest.json', document.baseURI), { cache: 'no-store' });
  if (!response.ok) throw new Error(`Deep zoom manifest request failed (${response.status})`);
  const manifest = await response.json();
  const chunk = manifest['src/deepZoom/runtime.js']?.file;
  if (!chunk) throw new Error('Deep zoom runtime is missing from the build manifest');
  // A failed module URL stays failed in the browser's module map. A fresh URL
  // retries the same emitted chunk without discarding the current cameras.
  const url = new URL(chunk, document.baseURI);
  url.searchParams.set('retry', String(++retrySequence));
  return import(/* @vite-ignore */ url.href);
}

// This is the only eager dependency on the deep engine. In particular, do not
// re-export Decimal or a worker factory from this module.
export function loadDeepZoom({ retry = false } = {}) {
  if (retry) pending = undefined;
  if (!pending) {
    const next = loadedRuntime ? Promise.resolve(loadedRuntime)
      : staticImportFailed ? retryFailedImport() : import('./deepZoom/runtime');
    pending = next
      .then(runtime => {
        loadedRuntime = runtime;
        return runtime;
      })
      .catch(error => {
        pending = undefined;
        staticImportFailed = true;
        throw error;
      });
  }
  return pending;
}
